import { LANGUAGE_TYPE } from 'common/enums'

export const getBrowserLanguage = (): LANGUAGE_TYPE => {
  return navigator.language.split('-')[0] as LANGUAGE_TYPE
}
